import { useState } from 'react';
import { useCiAuthStore } from '../auth/ciAuthStore';
import { useCiPoolStore } from '../authorization/ciPoolStore';
import { CiTimeWindowTabs } from '../components/CiTimeWindowTabs';
import { PageViewActivityPanel } from '../components/PageViewActivityPanel';
import { TIME_WINDOW_DAYS, type TimeWindow } from '../data/types';

export function PageViewsPage() {
  const userId = useCiAuthStore((s) => s.user_id);
  const leagueId = useCiPoolStore((s) => s.selectedLeagueId);
  const [window, setWindow] = useState<TimeWindow>('30d');

  return (
    <div className="ci-page-views">
      <section className="ci-section">
        <div className="ci-section__header">
          <div>
            <h1 className="ci-section__title">Pages consultées</h1>
            <p className="ci-section__meta">
              Consultez les pages les plus visitées et leur évolution. Ces statistiques mesurent
              les pages ouvertes dans le pool, pas les connexions des utilisateurs.
            </p>
          </div>
        </div>
        <CiTimeWindowTabs value={window} onChange={setWindow} />
      </section>

      {userId && leagueId ? (
        <PageViewActivityPanel
          userId={userId}
          leagueId={leagueId}
          days={TIME_WINDOW_DAYS[window]}
        />
      ) : (
        <div className="ci-empty">Sélectionnez un pool pour consulter ses pages visitées.</div>
      )}
    </div>
  );
}
